export default __webpack_public_path__ + "static/media/spitukmonastery.76eecb95.jpg";